import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { useSelector } from 'react-redux';
import { FaRegCircleUser } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ROLE from '../common/role';
import { useNavigate } from 'react-router-dom';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import defaultImage from '../assest/DAWACO_Icon.png'; 

const UserAllRefunds = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const user = useSelector(state => state?.user?.user);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [refundId, setRefundId] = useState('');

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRefundRequests = async () => {
    try {
        setLoading(true);
      const body = {
        user: user,
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : ''
      };

        const response = await fetch(SummaryApi.userRefundRequests.url, {
          method: SummaryApi.userRefundRequests.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          }, 
          body: JSON.stringify(body),
        });
        
        const responseData = await response.json();
        const refundData = responseData.data || [];

      setData(refundData);
    
    } finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
      navigate("/");
    }, 10000);

    if (user) {
      if (user?.role !== ROLE.GENERAL) {
        navigate("/");
        setLoading(false);
      } else if (user?.pharmacistOrPharmacy === 'pharmacist') {
        navigate("/");
        setLoading(false);
      } else {
        setLoading(false);
        clearTimeout(loadingTimeout);
        fetchRefundRequests();
      }
    }

    return () => clearTimeout(loadingTimeout);
  }, [user, navigate,startDate, endDate]);

  
  const handleClick = (refundId) => {
    setShowConfirm(true);
    setRefundId(refundId);
  };

  const handleConfirm = async (confirmed) => {
    if(confirmed){
      setLoadingAction(true); 
        try {
          await fetch(SummaryApi.removeRefundRequest.url, {
            method: SummaryApi.removeRefundRequest.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            }, 
            body: JSON.stringify({
              refundId: refundId,
            }),
          });
        } catch (error) {
        } finally {
          setShowConfirm(false);
          setLoadingAction(false);
          window.location.reload();
          toast.success('تم حذف الطلب بنجاح')
        }
    } else {
        setShowConfirm(false);
      }
      
  };

  return (
    
         <div className="min-h-[calc(100vh-120px)] lg:flex">
     {/* Mobile Toggle Button */}
     <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>

  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {user?.profilePic ? (
        <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{user?.name}</p>
    <p className='text-sm'>{user?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : user?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : user?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>
      {/* معلومات الموقع */}
      <div>
        <h3 className='text-xl font-bold mb-2 text-center'>ادارة شئون الحساب</h3>
        <Link
          to='/order-history'
          className={`block px-2 py-1 ${location.pathname === '/order-history' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          جميع الطلبات
        </Link>
        {user?.pharmacistOrPharmacy === 'pharmacy' && (
          <>
            <Link
              to='/PaymentHistory'
              className={`block px-2 py-1 ${location.pathname === '/PaymentHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              (المديونية) سجل المدفوعات
            </Link>
            <Link
              to='/userPaymentAndOrdersHistory'
              className={`block px-2 py-1 ${location.pathname === '/userPaymentAndOrdersHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              سجل حسابات دواكو
            </Link>

            <Link
              to='/userRefundRequests'
              className={`block px-2 py-1 ${location.pathname === '/userRefundRequests' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              طلبات الاسترجاع
            </Link>
          </>
        )}
      </div>
    </nav>
  </div>
</aside>
 <main className={` p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>

    <div >
                      {/* Date Filter Section */}
                      <div className="w-full flex justify-end items-start mb-4">
  <div className="text-right">
    <h2 className="text-xl font-bold mb-6">
      حدد المدة التي تريد ان تري بها جميع طلبات الاسترجاع
    </h2>

    <div className="flex gap-6 justify-end">
      {/* Start Date */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          تاريخ البداية
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>

      {/* End Date */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          تاريخ النهاية
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>
    </div>
  </div>
</div>


      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
        </div>
      ) : (

      

        data.length === 0 ? (
          <p className="text-center text-gray-500">لا يوجد طلبات استرجاع</p>
        ) : (
          
          
          
          <div className='p-4 w-full'>
            {data.map((item, index) => (
              <div key={item?._id || index} className="w-full lg:w-[200%] my-4">
                <p className='font-medium text-lg'>{moment(item?.createdAt).format('LL')}</p>
                <div className='border rounded-lg p-4 bg-gray-50 shadow-md'>
                  <div className='flex flex-col lg:flex-row justify-between'>
                    <div className='flex flex-col gap-4'>
                      <> 
                        <span style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#333333' }}>
                          طلب استرجاع من الطلب # {item?.refundFromOrderNumber}
                        </span>
                       {item?.refundSalesManName!=="" &&<span style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#333333' }}>
                           تم بواسطة مندوب  ({item?.refundSalesManName}) 
                        </span>}
                        {item?.refundSalesManName==="" &&<span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333333' }}>
                          تم بواسطة الصيدلية 
                        </span>}
                      </>
                      {item?.productDetails?.map((product, index) => (
                        <div key={product?.productId + index} className='flex gap-4 bg-white p-4 rounded-lg shadow-md border border-gray-200'>
                          <img
                            src={product?.productImage?.[0] || defaultImage} 
                            className='w-24 h-20 bg-gray-200 object-cover rounded-md'
                            alt={product?.productName }
                          />
                          <div className='flex-1'>
                            <div className='font-medium text-lg text-gray-800'>
                              {product?.productName}
                            </div>
                            <div className='flex items-center gap-4 mt-2'>
                              <div className='text-lg text-blue-800'>
                                {displayINRCurrency(product?.unitPrice)}
                              </div>
                              <p className='text-gray-700'>الكمية: {product?.quantity}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className='font-semibold ml-auto w-fit lg:text-lg'>
                      <div className='flex items-center mb-3'>
                        <span className='block mr-2 text-gray-600'>السعر الاجمالى :</span>
                        <span className='text-xl font-bold text-blue-800'>
                          {displayINRCurrency(item?.totalPrice || 0)}
                        </span>
                      </div>


                      {/* Buttons for Accept and Reject */}
                      <div className='mt-4 flex border-t pt-2 space-x-4 ml-10'>
                        <button
                          className='bg-blue-900 hover:bg-blue-700 text-white px-4 py-2 '
                          onClick={() => handleClick(item?._id)}
                        >
                          حذف الطلب
                        </button>
                      </div>

                 {/* Confirmation Modal */}
{showConfirm && (
    <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black bg-opacity-10"></div>

        {/* Modal */}
        <div className="bg-white p-6 rounded shadow-lg relative max-w-md mx-auto">
            {/* Close button (X) */}
            <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={() => handleConfirm(false)}
            >
                &#x2715; {/* X icon */}
            </button>

            {/* Centered title */}
            <h3 className="text-lg font-semibold mb-4 text-center">
                تأكيد حذف الطلب
            </h3>

            {/* Show loading icon or the confirmation message */}
            {loadingAction ? (
                <div className="flex justify-center items-center">
                    <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
                </div>
            ) : (
                <>
                    {/* Confirmation message */}
                    <p className="text-lg mb-4 text-center">
                       هل أنت متأكد أنك تريد حذف هذا الطلب ؟
                    </p>

                    {/* Buttons */}
                    <div className="mt-4 flex justify-center gap-4">
                        <button
                            className="bg-blue-800 hover:bg-blue-600 text-white px-4 py-2 rounded-lg"
                            onClick={() => handleConfirm(true)}
                        >
                            نعم
                        </button>
                        <button
                            className="bg-gray-300 px-4 py-2 rounded-lg"
                            onClick={() => handleConfirm(false)}
                        >
                            لا
                        </button>
                    </div>
                </>
            )}
        </div>
    </div>
)}


                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}
       </div>
       </main>
    </div>
   
  );
};

export default UserAllRefunds;
